import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';
import { Button } from './button';
import { X } from 'lucide-react';
import PannellumViewer from '../../utils/360Viewer';

const modalOverlayVariants = cva('fixed inset-0 bg-black opacity-50');

const modalContentVariants = cva(
  'fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full sm:w-96 bg-white rounded-lg p-4'
);

const modalCloseButtonVariants = cva('absolute top-2 right-2 text-black hover:text-gray-700');

const Modal = ({ isOpen, onClose, contentType, contentProps, children }) => {
  const { imageUrl, pannellumProps } = contentProps ?? {};

  const renderContent = () => {
    if (children) {
      return children; // ✅ render your custom content
    }
    if (contentType === 'image') {
      return (
        <img src={imageUrl} alt="Image Preview" className="w-full h-auto max-h-96 object-contain" />
      );
    }

    if (contentType === 'pannellum') {
      return <PannellumViewer {...pannellumProps} />;
    }

    return null;
  };

  return (
    <DialogPrimitive.Root open={isOpen} onOpenChange={onClose}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className={cn(modalOverlayVariants())} />
        <DialogPrimitive.Content className={cn(modalContentVariants())}>
          <DialogPrimitive.Close className={cn(modalCloseButtonVariants())}>
            <X className="h-6 w-6" />
          </DialogPrimitive.Close>
          <div className="flex justify-center mb-4">{renderContent()}</div>
          <Button variant="outline" onClick={onClose} className="w-full">
            Close
          </Button>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
};

export { Modal };
